import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-electronic-communication',
  templateUrl: './electronic-communication.component.html',
  styleUrls: ['./electronic-communication.component.scss']
})
export class ElectronicCommunicationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
